/* eslint-disable no-param-reassign */
import Echo from 'laravel-echo';
import store from '@/store';

export default {
  install(Vue, { socketAppId, socketAppKey, apiUrl }) {
    if (socketAppId && socketAppKey) {
      const echo = new Echo({
        broadcaster: 'socket.io',
        host: `${apiUrl.replace(/:?[0-9]*\/api/, '')}:6001`,
        // authEndpoint: `${config.apiUrl}/broadcasting/auth`,
        key: socketAppId,
        auth: {
          headers: {
            Authorization: `Bearer ${store.state.auth.token}`,
          },
        },
      });

      store.watch((state) => {
        echo.options.auth.headers.Authorization = `Bearer ${state.auth.token}`;
      });

      Vue.prototype.$echo = echo;
    }
  },
};



// WEBPACK FOOTER //
// ./src/modules/laravel-echo/src/index.js